import React from 'react'
import { Table } from 'components'
import RemoveIcon from 'components/atoms/Icons/Controls/Close'
import { TSegmentTeamRow } from '../../types'
import styles from './SegmentForm.module.scss'

interface SegmentFormTeamTableProps {
  data: TSegmentTeamRow[]
  onRemove: (id: string) => void
}

const SegmentFormTeamTable = ({ data, onRemove }: SegmentFormTeamTableProps): React.ReactElement => {
  return (
    <>
      <Table>
        <Table.Head>
          <Table.Row>
            <Table.Cell head>Name</Table.Cell>
            <Table.Cell head>Email</Table.Cell>
            <Table.Cell head>&nbsp;</Table.Cell>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {data.map(({ id, name, email }) => (
            <Table.Row key={id}>
              <Table.Cell>{name}</Table.Cell>
              <Table.Cell>{email}</Table.Cell>
              <Table.Cell className={styles['action-cell']}>
                <button className={styles['remove-button']} type="button" onClick={() => onRemove(id)}>
                  <RemoveIcon />
                </button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  )
}

export default SegmentFormTeamTable
